import React, { useMemo } from 'react';
import Button from '@atlaskit/button';
import { Text } from '@atlaskit/primitives';
import SectionMessage from '@atlaskit/section-message';
import { FormattedMessage, useIntl } from '@atlassian/jira-intl';
import { useAttributes } from '@atlassian/jira-servicedesk-insight-object-details-store/src/controllers/store/index.tsx';
import { Link } from '@atlassian/react-resource-router';
import { messages } from './messages.tsx';
import { extractEncodedServiceId } from './utils.tsx';

const Bold = (chunks: React.ReactNode[]) => <Text as="strong">{chunks}</Text>;

export const RestrictedSchemaEditingInformation = () => {
	const { formatMessage } = useIntl();
	const [attributes] = useAttributes();
	const encodedServiceId = useMemo(() => extractEncodedServiceId(attributes), [attributes]);

	if (encodedServiceId == null) {
		return null;
	}

	return (
		<SectionMessage
			title={formatMessage(messages.title)}
			actions={[
				<Button
					key="edit"
					href={`/jira/servicedesk/service-modal/${encodedServiceId}`}
					appearance="primary"
					component={Link}
				>
					{formatMessage(messages.edit)}
				</Button>,
			]}
		>
			<Text as="p">
				<FormattedMessage {...messages.description} values={{ bold: Bold }} />
			</Text>
		</SectionMessage>
	);
};
